import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_spot_cancel_pickup.svg'


const _hoisted_1 = { class: "flex justify-center w-full h-full flex-col items-center gap-y-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "ill_spot_cancel_pickup",
  class: "w-40"
}, null, -1)
const _hoisted_3 = { class: "flex flex-col text-gray-lp-800 text-sm gap-y-2 justify-center" }
const _hoisted_4 = { class: "font-bold text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row gap-x-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.headerMessage), 1),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.message), 1)
    ]),
    (!_ctx.isNoArea)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_lp_button, {
            title: _ctx.$t('pickupDashboard.manageArea.createTitle'),
            textColor: "white",
            color: "red-lp-100",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onAdjustArea'))),
            iconLeft: "plus-white",
            fontWeight: "semibold",
            isWidthFull: "",
            sizeIcon: "16px"
          }, null, 8, ["title"]),
          _createVNode(_component_lp_button, {
            title: _ctx.$t('pickupDashboard.manageArea.viewYourArea'),
            textColor: "red-lp-100",
            color: "red-lp-100",
            outline: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onViewArea'))),
            iconLeft: "ics_o_maps",
            fontWeight: "semibold",
            isWidthFull: "",
            sizeIcon: "16px"
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
  ]))
}